<script setup lang="ts">
import http from '@/services/http'

let clicked = false

function change(lang: string) {
	if (clicked) return
	clicked = true

	http.get('/lang/' + lang).then(() => {
		setTimeout(() => {
			location.reload()
		}, 1)
	})
}
</script>

<template>
	<span>
		<a href="#" class="lang-selector fw-bold" data-lang="et" @click="change('et')">EST</a>
		<span class="mx-2">|</span>
		<a href="#" class="lang-selector fw-bold" data-lang="en" @click="change('en')">ENG</a>
	</span>
</template>

<style lang="sass" scoped></style>
